import type { AppState } from '@console/reducers';
import type { LocalProject } from '@console/reducers/projects';
import { createSelector } from 'reselect';

const getProjectDetailMarketingIndustry = (state: AppState) =>
  state.projectDetail.marketingIndustry;

export const getMarketingIndustry = createSelector(
  [getProjectDetailMarketingIndustry],
  (marketingIndustry): NonNullable<LocalProject['marketingIndustry']> => ({
    name: marketingIndustry.name ?? '',
    urlCode: marketingIndustry.urlCode ?? ''
  })
);
